import { notifications } from '@mantine/notifications';
import { IconMoodPuzzled } from '@tabler/icons-react';
import { useQuery } from '@tanstack/react-query';
import { isNetworkError } from '@xver/libs/connectionNotifier';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Endpoints } from '../../../../../apis';

export function useBackupSettingsQuery(instanceId: number) {
    const { t } = useTranslation('cloudComputeInstance');
    const hasShownError = useRef(false);

    const query = useQuery({
        queryKey: ['api.v1.backups.settings', instanceId],
        queryFn: () => Endpoints.v1.Backups.getBackupSetting(instanceId),
        enabled: instanceId > 0,
        retry: 2,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
        refetchInterval: 30_000,
    });

    const { data, isPending, error, refetch } = query;

    useEffect(() => {
        if (error && !isNetworkError(error) && !hasShownError.current) {
            hasShownError.current = true;
            notifications.show({
                title: t('backup.queryFailedTitle'),
                message: t('backup.settingsQueryFailedMessage'),
                icon: <IconMoodPuzzled size={32} color={'#eb5757'} />,
            });
        }

        if (!error) {
            hasShownError.current = false;
        }
    }, [error, t]);

    return { data, isPending, refetch };
}
